var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkOrangeKg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.113281,
    y: 0.75,
    width: 68.6176,
    height: 68.6176,
    rx: 9.80251,
    fill: "#FFCBB4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6134 16.3804C17.6 16.5077 16.5016 17.0065 15.7375 17.691C15.0743 18.2906 14.5012 19.2138 14.2306 20.1265C14.0449 20.7579 13.9918 21.9253 14.1245 22.5779C14.5277 24.5571 15.9657 26.1171 17.8759 26.6477C18.5498 26.8334 19.5686 26.8812 20.2106 26.7538C22.2428 26.3453 23.8241 24.8861 24.3494 22.9281C24.5139 22.3285 24.5457 21.2142 24.4237 20.6093C24.2008 19.5163 23.7604 18.6726 22.9963 17.8979C21.8502 16.7412 20.2265 16.1734 18.6134 16.3804ZM21.8449 18.8424C22.0094 18.9273 22.0624 19.0175 22.0624 19.2298C22.0624 19.3412 21.8926 19.5428 21.2612 20.1742L20.4547 20.9808L20.5183 21.1506C20.6881 21.644 20.513 22.2436 20.0992 22.5938C19.4571 23.1457 18.433 22.9175 18.0775 22.1375C17.929 21.8138 17.9449 21.3204 18.1094 20.9967C18.3906 20.4395 19.0008 20.1583 19.6057 20.3175L19.8816 20.3918L20.6404 19.6277C21.3196 18.9379 21.5106 18.7787 21.6539 18.7681C21.6751 18.7628 21.7653 18.8 21.8449 18.8424Z",
    fill: "#ED5E2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1875 38.1193V48.583L19.2646 48.5724L20.3365 48.5565L20.3524 38.1034L20.363 27.6504H19.2753H18.1875V38.1193Z",
    fill: "#ED5E2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9825 29.8895C26.9612 29.9055 26.9453 34.1238 26.9453 39.2548V48.583H37.7167H48.4882L48.4776 39.2283L48.4616 29.8789H44.4555H40.4494L40.4335 32.861L40.4229 35.8483H37.7433H35.0637V32.8822C35.0637 30.2291 35.0531 29.9161 34.9788 29.8842C34.8674 29.8418 27.0249 29.8418 26.9825 29.8895Z",
    fill: "#ED5E2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5898 50.4669V51.5547H34.7715H53.9531V50.4669V49.3792H34.7715H15.5898V50.4669Z",
    fill: "#ED5E2A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9651 53.0241L21.9811 53.6502L24.2255 53.6661L26.4647 53.6768V53.04V52.4033H24.2096H21.9492L21.9651 53.0241Z",
    fill: "#ED5E2A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0742 53.04V53.6768H45.3293H47.5844V53.04V52.4033H45.3293H43.0742V53.04Z",
    fill: "#ED5E2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkOrangeKg);
export default __webpack_public_path__ + "static/media/dark_orange_kg.f64454330d01919c727271e881adb327.svg";
export { ForwardRef as ReactComponent };